export const DISPUTES_ENABLED = false;
